//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Contingent
import com.tixforgigs.apax.models.Event
import com.tixforgigs.apax.models.Seating
import com.tixforgigs.apax.models.TicketOrder

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The ticket metadata model, which contains additional information about the ticket
* 
* @param contingent 
* @param event 
* @param order 
* @param seating 
*/
@Serializable

data class TicketMetadata (


      @SerialName(value = "contingent") @Required val contingent: Contingent,


      @SerialName(value = "event") @Required val event: Event,


      @SerialName(value = "order") @Required val order: TicketOrder,


      @SerialName(value = "seating") val seating: Seating? = null


) {




  }

